module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAYAAACgu+4kAAAA4UlEQVQokaXSvUpDQRiE4SdLCrEVsQ/kKsSfgLGNFum9BittBCvTeA25BW0lXYhYJQSboBYKFsYgWmhqi7OBw0lO/Mk0C/PNO7vsbmFUr8AKTrCPNTyiiXOJDnGAEoa4wCneCqN6ZRUdlE2rFdedGbN7rBdxlgPngROV0QiozQn9pL2A5QUKlgLaCxR0Ao4x/gc8xlFAT3IPn3+AvyRP3g3RaKGK91/AH9jFFYTU4AZbeJkDD7GN64kRMoFbbEh+YlZP2EQ/bWYL4CGWDFLeIMJ32XAx56jPseQyblLD66zgNxngKpni7w6vAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/已收藏.png
// module id = zk1s
// module chunks = 1